// eslint-disable-next-line @typescript-eslint/no-floating-promises
import('./bootstrap')
